import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { unregister } from 'registerServiceWorker';
import createHistory from 'history/createBrowserHistory';
import { MuiThemeProvider } from '@material-ui/core/styles';
import config from 'config/config';
import theme from 'config/theme';

import { addBuildInfo } from 'utils';

import './styles/index.css';
import { Provider } from 'react-redux';
import Routes from './routes/Routes';
import configureStore from './redux/configureStore';

import DevTools from './components/common/devTools/DevTools';

const initialState = window.REDUX_INITIAL_STATE || {};
const store = configureStore(initialState);
const history = createHistory({
  forceRefresh: false,
});

class Index extends Component {
  componentDidMount() {
    addBuildInfo();
    this.showIntercomWidget();
  }

  showIntercomWidget() {
    if (config.showIntercomGlobally !== 'true') return false;
    window.Intercom('boot', {
      app_id: config.intercomePublicKey,
    });
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <Router history={history}>
            <Routes />
          </Router>
        </Provider>
      </MuiThemeProvider>
    );
  }
}

ReactDOM.render(<Index />, document.getElementById('root') || document.createElement('div'));

/**
 * 		The debug version
 * */

if (process.env.REACT_APP_DEBUG === 'true') {
  const dom = document.createElement('div');
  dom.id = 'dev-tools';
  document.body.appendChild(dom);
  ReactDOM.render(<DevTools store={store} />, document.getElementById('dev-tools'));
}

unregister();

export { Index, store, history };



// WEBPACK FOOTER //
// ./src/index.js